import React from 'react'
import Button from 'lib/ui/Button'
import {useUpdateWidget} from 'lib/event-api/widgets/use-update-widget'
import {Widget} from 'Event/Widget/template'

export default function SaveButton(props: {widget: Widget | null}) {
  const {widget} = props
  const {mutate, isLoading} = useUpdateWidget()

  if (!widget) {
    return null
  }

  const handleSave = () => {
    mutate({
      ...widget,
      allowed_origins:
        widget.allowed_origins?.length === 0 ? null : widget.allowed_origins,
    })
  }

  return (
    <Button
      disabled={isLoading}
      variant="contained"
      color="success"
      type="button"
      onClick={handleSave}
      aria-label="save widget"
    >
      Save Changes
    </Button>
  )
}
